import React, {useState,useEffect} from "react";
import { Box, Flex, Textarea} from "@chakra-ui/react";

export default function FormTextAreaInput({
  onChange, currentValue, isRequiredField,
  name, label, sublabel, htmlFor, type, defaultValue, charLimit, isDisabled, placeholder, fontSize
}) {
 
 
  const [remainingChar, setRemainingChar] = useState(charLimit ? charLimit : "")
  useEffect(()=> {
    if (charLimit && currentValue) {
      const currentCharacters = currentValue ? currentValue?.length : 0;
      setRemainingChar(charLimit - currentCharacters)
    }
  },[charLimit, currentValue])
  return (
    <Box htmlFor={htmlFor} w='100%'>
      
      <Box fontSize='0.875em' lineHeight='1.375em' fontWeight='500' color='gray.700'> 
        {label} {isRequiredField && <Box as='span' color='brandPink.500'>*</Box>}
      </Box>
      {sublabel && <Box fontSize='0.8em' lineHeight='1.25em' mt='0.2em' fontWeight='400' color='gray.500'> 
        {sublabel} 
      </Box>
      }

      <Box mt='0.625em'>
        <Textarea 
          name={name} 
          variant={'outline'} 
          defaultValue={defaultValue && defaultValue}
          // value={defaultValue}
          placeholder={placeholder && placeholder}
          type={type} 
          isDisabled={isDisabled}
          className='white-space-preline'
          maxLength={charLimit}
          w='100%' 
          h='2.5em' 
          fontSize={ fontSize ? fontSize :'1em' }
          lineHeight='1.375em' 
          rounded ='0.25em' 
          onChange={(event) => onChange(event)}/>
          
          {charLimit && <Flex justify='flex-end' w='100%' color='gray.500' fontSize='0.65em' pt='0.2em'>
            {remainingChar} characters remaining
          </Flex>
          }
      </Box>

    </Box>
  );
  
}


